export default {
    ENV: 'test',
    authApiUrl: 'https://testapi.imaginelearning.com',
    redirectUri: 'https://test.my.imaginelearning.com/login/signin',
    auth0RedirectUri: 'https://test.my.imaginelearning.com/login/sso',
    auth0Audience: 'https://api.my.imaginelearning.com',
    auth0AuthorizeUrl: 'https://imaginelearning-test.auth0.com/authorize',
    auth0ClientId: 'vvTmU0S3zkSW3lihKyKkDMFDNOEVJ2aT',
    unityLaunchUrl: 'https://test.my.imaginelearning.com/player',
    pssUrl: 'https://testapi.imaginelearning.com/productSelection',
    imlpApiUrl: 'https://identity.qa.edgenuityapp.com/api',
    flagrApiUrl: 'https://admin.imlp-qa.edgenuityapp.com/api/flags/api/v1',
    oauthSsoUrl: 'https://identity.qa.edgenuityapp.com/api/auth/sso/oauth',
    cleverSsoUrl: 'https://identity.qa.edgenuityapp.com/api/auth/sso/clever',
    permissionsApiUrl: 'https://testapi.imaginelearning.com/v1.0/permissions',
    configCatApiUrl: 'https://flag-proxy.platform-nonprod.imaginelearning.com',
    configCatSdkKey: 'configcat-proxy/axs-sso-imlp-qa',
    useConfigCat: true,
    configCatPollIntervalSeconds: 60,
    configCatRequestTimeoutMs: 30000,
    configCatMaxRetries: 3
};
